module.exports = __webpack_public_path__ + "img/register.78ad273d.png";